document.addEventListener("DOMContentLoaded", function () {
  const serials = [];
  const listContainer = document.getElementById("serialList");
  const customerId = document.getElementById("ecoco-customerId").dataset.value;
  const hash = document.getElementById("ecoco-customerIdHash").dataset.value;
  const C_SEP = document.getElementById("ecoco-C_SEP").dataset.value;
  const baseUrl  = document.getElementById("ecoco-baseUrl").dataset.value;

  // シリアル番号をAPIを通じて削除する関数
  async function deleteList(serialInput) {
    await fetch(baseUrl + "function-ecoco-device-delete", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerId: customerId,
        sn: serialInput,
        hash: hash,
      }),
    })
      .then((data) => {
        console.log("delete successed!");
      })
      .catch((error) => {
        console.error("Error fetching serials:", error);
      });
  }

  // シリアル番号をAPIを通じて追加する関数
  async function addList(serialInput) {
    await fetch(baseUrl + "function-ecoco-device-add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        customerId: customerId,
        sn: serialInput,
        hash: hash,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("add successed!");
      })
      .catch((error) => {
        console.error("Error fetching serials:", error);
      });
  }

  // シリアル番号の一覧をサーバーから取得し更新する関数
  async function getList() {
    await fetch(baseUrl + "function-ecoco-device-read", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ customerId: customerId, hash: hash }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.tags.includes(",")) {
          serials.push(...data.tags.split(","));
        } else {
          serials.push(...data.tags);
        }
        displaySerials(serials);
      })
      .catch((error) => {
        console.error("Error fetching serials:", error);
      });
  }

  // シリアル番号の一覧をサーバーから更新する関数
  async function updateList(originValue, newValue) {
    await fetch(baseUrl + "function-ecoco-device-update", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ customerId: customerId, hash: hash, from: originValue, to: newValue }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("updated successed!");
      })
      .catch((error) => {
        console.error("Error fetching serials:", error);
      });
  }

  //テーブルセルの作成
  function createTableCell(content, isText = true, colspan = 1) {
    const td = document.createElement("td");
    if (isText) {
      td.textContent = content;
      td.className = "text-start ps-0";
      td.colSpan = colspan;
    } else {
      td.appendChild(content);
      td.className = "text-end ps-0";
      td.colSpan = colspan;
    }
    return td;
  }

  //ボタンの作成
  function createButton(label, onClickHandler) {
    const button = document.createElement("button");
    button.textContent = label;
    button.className = "device_update_btn btn float-end";
    button.onclick = onClickHandler;
    return button;
  }

  // 取得したシリアル番号をリストとして表示する関数
  function displaySerials(serials) {
    listContainer.innerHTML = "";
    const table = document.createElement("table");
    table.className = "table table-vertical";

    const thead = document.createElement("thead");
    const thtr = document.createElement("tr");
    thtr.appendChild(createTableCell("ラベル"));
    thtr.appendChild(createTableCell("SN(シリアルナンバー)",true,2));
    //thtr.appendChild(createTableCell(""));
    thead.appendChild(thtr);
    table.appendChild(thead);

    serials.sort();
    serials.forEach((serial, index) => {
      const arr = serial.split(C_SEP);
      const serial_label = arr.length > 1 ? arr[0] + " " : "";
      const serial_value = arr.length > 1 ? arr[1] : arr[0];

      const div = document.createElement("div");
      div.className = "d-flex mt-1 flex-column flex-md-row";
      div.appendChild(createButton("編集", () => editSerial(index)));
      div.appendChild(createButton("削除", () => deleteSerial(index)));

      const tr = document.createElement("tr");
      tr.appendChild(createTableCell(serial_label));
      tr.appendChild(createTableCell(serial_value));
      tr.appendChild(createTableCell(div, false));
      table.appendChild(tr);
    });

    listContainer.appendChild(table);
  }

  // シリアル番号を編集する関数
  function editSerial(index) {
    const modal = document.getElementById("modal");
    const serialInput = document.getElementById("serialInput");
    const originalValue = serials[index];
    const arr = serials[index].split(C_SEP);
    serialLabel.value = arr.length > 1 ? arr[0] : "";
    serialInput.value = arr.length > 1 ? arr[1] : arr[0];
    showModal();
    document.getElementById("saveButton").onclick = function () {
      const newValue = serialLabel.value + C_SEP + serialInput.value;
      serials[index] = newValue;
      updateList(originalValue, newValue);
      displaySerials(serials);
      hideModal();
    };
  }

  // シリアル番号を削除する関数
  function deleteSerial(index) {
    if (confirm("このシリアル番号を削除してもよろしいですか？")) {
      const serialInput = document.getElementById("serialInput");
      deleteList(serials[index]);
      serials.splice(index, 1);
      displaySerials(serials);
    }
  }

  // 入力されたシリアルラベルのバリデーションを行う関数
  function validateLabel(labelValue) {
    if (labelValue.includes(C_SEP)) {
      $("#device_input_btn_error_message_label").append(
        '<p><i class="fa fa-exclamation-triangle"></i>' +
          C_SEP +
          "は予定語なのでご利用できません。</p>"
      );
      return false;
    }
    return true;
  }

  // 入力されたシリアル番号のバリデーションを行う関数
  function validateSN(imeiValue) {
    if (imeiValue.match(/[0-9]+/g) != imeiValue) {
      $("#device_input_btn_error_message").append(
        '<p><i class="fa fa-exclamation-triangle"></i>13桁の数字を入力してください。</p>'
      );
      return false;
    } else if (imeiValue.length < 13) {
      $("#device_input_btn_error_message").append(
        '<p><i class="fa fa-exclamation-triangle"></i>13桁の数字を入力してください。</p>'
      );
      return false;
    }
    return true;
  }

  // 新しいシリアル番号を追加するためのモーダルを表示する関数
  function addSerial() {
    const modal = document.getElementById("modal");
    const serialLabel = document.getElementById("serialLabel");
    const serialInput = document.getElementById("serialInput");
    serialLabel.value = "";
    serialInput.value = "";
    showModal();
    document.getElementById("saveButton").onclick = function () {
      resetErrorMessage();
      const isValid = validateSN(serialInput.value);
      const isValid2 = validateLabel(serialLabel.value);
      if (isValid && isValid2) {
        const data = serialLabel.value + C_SEP + serialInput.value;
        serials.push(data);
        addList(data);
        displaySerials(serials);
        hideModal();
      }
    };
  }

  // モーダルを表示する関数
  function showModal() {
    const modal = document.getElementById("modal");
    modal.style.display = "flex";
  }

  // モーダルを非表示にする関数
  function hideModal() {
    const modal = document.getElementById("modal");
    modal.style.display = "none";
    resetErrorMessage();
  }

  //エラーを初期化する関数
  function resetErrorMessage() {
    $("#device_input_btn_error_message").empty();
    $("#device_input_btn_error_message_label").empty();
  }

  document.querySelector(".close-button").addEventListener("click", hideModal);
  document.getElementById("addButton").addEventListener("click", addSerial);
  getList();
});
